/*
  The picture the whole site shares when a link to it is posted anywhere.

  It lives in `shared` because all three workspaces set it: the React pages
  and the static index.html shell, every Astro layout, and the server, which
  rewrites the shell's tags for a handful of routes before a social crawler
  sees them. It used to be typed into fourteen places across those three, so
  replacing it meant finding all fourteen, and the ones that were missed kept
  posting the old picture.

  The file itself sits in `client/public`, which is served at the site root,
  so the URL resolves for a page served by either build.

  The dimensions are the file's own, measured rather than assumed: several
  pages declared 1200x630 for a picture that was 1731x909, and a declared
  size that does not match the file is a size a scraper can lay out wrongly
  before it has fetched anything.
*/
export const SITE_URL = 'https://superschema.ai';
export const FEATURED_IMAGE = `${SITE_URL}/design-system/og/featured-image.jpg`;
export const FEATURED_IMAGE_WIDTH = '1200';
export const FEATURED_IMAGE_HEIGHT = '628';
export const FEATURED_IMAGE_TYPE = 'image/jpeg';
